import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { certificationList } from "../../../actions/admin/certification/certification_action";
import AppBody from "../../components/AppBody";
import ShowCertificationDetailsModel from "./ShowCertificationDetailsModel";
import CertificationShowModal from "../../home/CertificationShowModal";
const CertificationList = () => {
  const state = useSelector((state) => state.certificationReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(certificationList({ search: "" }));
  }, []);

  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const [searchText, setSearchText] = useState("");

  const getViewDetails = (data) => {
    console.log(data);
    setShow(true);
    setData(data);
  };
  const resetPopup = () => {
    setShow(false);
    setData({});
  };

  const editCertificationClick = (id) => {
    navigate("/certification/edit/" + id);
  };

  const deleteCertificationClick = (id) => {};

  const searchCertificate = () => {
    dispatch(certificationList({ search: searchText }));
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
            <div className="card-body p-3 w-100 bg-current border-0 d-flex rounded-lg">
              <Link to={"/admin/home"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Certification List
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/certification/create"}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Create Certification"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>
            </div>

            <div className="card-body p-0 w-100 border-0 cer-search-table">
              <div className="row">
                <div className="col-lg-2 mb-3" />
                <div className="col-lg-6 mb-3">
                  <input
                    type="text"
                    onChange={(e) => {
                      e.target.value
                        ? setSearchText(e.target.value)
                        : dispatch(certificationList({ search: "" }));
                    }}
                    className="form-control ad-search-cer-tb"
                  />
                </div>
                <div className="col-lg-2 mb-3">
                  <button
                    type="button"
                    className="btn  btn-common ad-serach-cer-btn"
                    onClick={() => searchCertificate()}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div className="table-responsive gridtable">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Name</th>
                      <th>Certification Type</th>
                      <th>Exam</th>
                      <th>Cost($)</th>
                      <th>Cost(INR)</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.product_name}</td>
                          <td>{li.certification_type}</td>
                          <td>{li.exam}</td>
                          <td>{li.cost_doller}</td>
                          <td>{li.cost_inr}</td>
                          <td>
                            <input
                              type="button"
                              value="View"
                              className="btn approve_btn btn-common"
                              onClick={() => getViewDetails(li)}
                            />
                            <input
                              type="button"
                              value="Edit"
                              onClick={() => editCertificationClick(li.id)}
                              className="btn approve_btn btn-common"
                            />
                            <input
                              type="button"
                              value="Delete"
                              onClick={() => deleteCertificationClick(li.id)}
                              className="btn approve_btn btn-common"
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {show && (
            <CertificationShowModal
              show={show}
              certificationData={data}
              handelCloseShow={() => resetPopup()}
            />
          )}
        </div>
      }
    />
  );
};

export default CertificationList;
